angular.module('zc.projects')

.directive 'zcCampaignCouponData', (CampaignStats, Devise, $filter) ->
  restrict: 'E'
  scope: {
    project: '='
    campaign: '='
    filters: '='
  }
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_coupon_data.html'

  link: (scope, element, attrs) ->
    scope.Devise = Devise
    updateData = ->
      CampaignStats.aggregate
        dimension: 'daily'
        campaign_id: scope.campaign.id
        apikey: scope.campaign.apikey
        start_at: scope.filters.start_at
        end_at: scope.filters.end_at
      .then (campaign_stats) ->
        scope.stats = CampaignStats.groupById(campaign_stats)[scope.campaign.id]
        current_incentive = scope.campaign.current_incentive
        is_coupon_code_type = current_incentive && current_incentive.incentive_type in ['coupon_code', 'unique_coupon_code']
        scope.rate_to_display = if is_coupon_code_type and scope.stats.experimental.campaign_coupon_used_rate > 0
          $filter('number')(scope.stats.experimental.campaign_coupon_used_rate * 100 , 2)
        else
          '- ' # show - % for non coupon code incentives
    scope.$watch 'filters', updateData, true



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_coupon_data.directive.coffee